import { initializeApp } from "firebase/app";
import {
  initializeFirestore,
  persistentLocalCache,
  CACHE_SIZE_UNLIMITED,
  clearIndexedDbPersistence,
  connectFirestoreEmulator,
} from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAuth, connectAuthEmulator } from "firebase/auth";

import { firebaseConfig } from "./config";

const app = initializeApp(firebaseConfig);

export const database = initializeFirestore(app, {
  localCache: persistentLocalCache({ size: CACHE_SIZE_UNLIMITED }),
});

clearIndexedDbPersistence(database);

export const functions = getFunctions(
  app,
  process.env.REACT_APP_ADMIN_BASE_URL,
);
export const auth = getAuth(app);
export const storage = getStorage();

if (process.env.REACT_APP_USE_EMULATORS === "true") {
  // Use REACT_APP_EMULATOR_HOST when testing from Android emulator (e.g. 10.0.2.2)
  // so the emulator can reach the host machine's emulators and auth redirects work.
  const emulatorHost =
    process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  connectFunctionsEmulator(functions, emulatorHost, 5001);
  connectFirestoreEmulator(database, emulatorHost, 8080);
  connectStorageEmulator(storage, emulatorHost, 9199);
  connectAuthEmulator(auth, `http://${emulatorHost}:9099`);
}
